import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import BusinessComponents from '@toy/business-components';
import { useInstances } from '@/hooks/use-instances';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import $filters from '@/core/plugins/filter';
import i18n from '@/lang';
import { getLanguageData } from '@/lang/utils';
import componentsInstall from '@/core/plugins/components-install';
import 'normalize.css';
import '@/styles/index.scss';
import 'virtual:uno.css';
import '@toy/business-components/dist/style.css';
import './core/plugins/permission';
import './core/plugins/iframe';
import './core/plugins/track';
import attachFastClick from 'fastclick';
import { useProvide } from '@toy/v-use';
import http from '@/core/http';

const { setVueInstance } = useInstances();
export const app = createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus, {
    size: 'default',
    locale: getLanguageData(),
  })
  .use(i18n)
  .use(BusinessComponents, undefined, http)
  .use($filters);
setVueInstance(app);
componentsInstall(app);
useProvide(app, { http });
app.mount('#app');
attachFastClick(document.body);
